import styled from 'styled-components';

const TooltipBody = styled.div`
  color: var(--primary-background);
  font-size: 12px;
`;
export default TooltipBody;
